import React from 'react';

interface ArcData {
  label: string;
  value: number;
  color?: string;
}

interface Props {
  data: ArcData[];
  colors?: string[];
  width?: number;
  height?: number;
  innerRadius?: number;
  outerRadius?: number;
  gap?: number;
  rounded?: boolean;
  avatarPercentage?: number;
  avatarUrl?: string;
}
const defaultColors = ['#3AB4B4', '#72DCC1', '#BDCE3B', '#E9D437', '#608FDA'];
export const SemiCirclePie: React.FC<Props> = ({
  data,
  width = 200,
  height = 100,
  innerRadius = 40,
  outerRadius = 80,
  gap = 0,
  rounded = false,
  avatarPercentage = 0,
  avatarUrl,
  colors = defaultColors, 
}) => {
  const total = data.reduce((sum, d) => sum + d.value, 0);
  const centerX = width / 2;
  const centerY = height;
  const radius = (innerRadius + outerRadius) / 2;

  const totalAngle = Math.PI;
  const gapInRad = (gap * Math.PI) / 180;
  const totalGapAngle = gapInRad * data.length;
  const anglePerValue = (totalAngle - totalGapAngle) / total;

  let startAngle = -Math.PI;

const paths = data.map((d, i) => {
  const angle = d.value * anglePerValue;
  const endAngle = startAngle + angle;

  const x1 = centerX + outerRadius * Math.cos(startAngle);
  const y1 = centerY + outerRadius * Math.sin(startAngle);
  const x2 = centerX + outerRadius * Math.cos(endAngle);
  const y2 = centerY + outerRadius * Math.sin(endAngle);

  const x3 = centerX + innerRadius * Math.cos(endAngle);
  const y3 = centerY + innerRadius * Math.sin(endAngle);
  const x4 = centerX + innerRadius * Math.cos(startAngle);
  const y4 = centerY + innerRadius * Math.sin(startAngle);

  const largeArc = angle > Math.PI ? 1 : 0;

  const pathData = `
    M ${x1} ${y1}
    A ${outerRadius} ${outerRadius} 0 ${largeArc} 1 ${x2} ${y2}
    L ${x3} ${y3}
    A ${innerRadius} ${innerRadius} 0 ${largeArc} 0 ${x4} ${y4}
    Z
  `;

  startAngle = endAngle + gapInRad;

 const fillColor = d.color || colors[i % colors.length];

  return (
    <path
      key={i}
      d={pathData}
      fill={fillColor}
      stroke="#f5f5f5"
      strokeWidth={gap}
      strokeLinejoin={rounded ? 'round' : 'miter'}
    />
  );
});

const avatarRadius = 15; // since image is 30x30

// ✅ FIX: Correct avatar position calculation
const avatarAngle = -Math.PI + (Math.PI * avatarPercentage) / 100;
const avatarX = centerX + radius * Math.cos(avatarAngle) - avatarRadius;
const avatarY = centerY + radius * Math.sin(avatarAngle) - avatarRadius;


  return (
<svg width={width} height={height + 40} style={{ overflow: 'visible' }}>
    <defs>
      <clipPath id="avatar-clip">
        <circle cx={avatarX + avatarRadius} cy={avatarY + avatarRadius} r={avatarRadius} />
      </clipPath>
    </defs>

    {paths}

    {avatarUrl && (
      <>
        {/* ✅ FIX: White border with larger radius */}
        <circle
          cx={avatarX + avatarRadius}
          cy={avatarY + avatarRadius}
          r={avatarRadius + 2} // Slightly larger for white border
          fill="white"
          style={{ filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.3))' }}
        />

        {/* ✅ FIX: Image centered and clipped */}
        <image
          href={avatarUrl}
          x={avatarX}
          y={avatarY}
          width={avatarRadius * 2}
          height={avatarRadius * 2}
          clipPath="url(#avatar-clip)"
        />
      </>
    )}
  </svg>

  );
};
